import axios from 'axios'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import axiosJsonpAdapter from 'axios-jsonp' // JSONPを取り扱うためのアダプター

interface ZipcloudResponse {
  status: number
  message: string | null
  results: ZipcloudResponseResult[] | null
}

interface ZipcloudResponseResult {
  address1: string
  address2: string
  address3: string
  kana1: string
  kana2: string
  kana3: string
  prefcode: string
  zipcode: string
}

/**
 * 郵便番号から住所を検索する
 *
 * 詳しいAPI仕様は下記参照。
 *
 * [郵便番号データ配信サービス - zipcloud](https://zipcloud.ibsnet.co.jp/)
 */
export async function zipcloud(zipcode: string) {
  return axios
    .get<ZipcloudResponse>('https://zipcloud.ibsnet.co.jp/api/search', {
      params: { zipcode },
      adapter: axiosJsonpAdapter,
    })
    .then(({ data }) => data)
    .then(({ status, message, results }) => {
      if (status === 400) {
        throw '郵便番号が正しくありません'
      } else if (status === 500) {
        // 大元のAPI側から返されたエラー
        throw message
      } else if (results === null) {
        // 該当する住所が存在しない
        throw '住所が見つかりませんでした'
      } else {
        // 合致する住所の一覧から最初のデータを返す
        return results[0]
      }
    })
}
